import Constants from "expo-constants";

import type { RuntimeInfo } from "./types";

export function getRuntimeInfo(): RuntimeInfo {
  return {
    platform: "web",
    nativeVersion: Constants.expoConfig?.version ?? null,
    nativeBuild: null,
    runtimeVersion: null,
    channel: null,
    updateId: null,
    updateCreatedAt: null,
    isEmbeddedLaunch: true,
    updatesEnabled: false,
  };
}
